import React, { useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import "./index.scss";

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = () => {
  const [threshold, setThreshold] = useState(0);

  const originalData = {
    labels: ["Dadar", "Thane", "Dombivali", "Kalyan", "Mulund"],
    datasets: [
      {
        label: "Dataset",
        data: [300, 50, 110, 140, 160],
        backgroundColor: [
          "#FDD561",
          "#7C9FFE",
          "#3B52DA",
          "#39DE9F",
          "#E66B37",
        ],
        hoverBackgroundColor: [
          "#FDD561",
          "#7C9FFE",
          "##3B52DA",
          "#39DE9F",
          "#E66B37",
        ],
        borderWidth: 1,
        cutout: "70%", // Adjust this value to make the donut chart slimmer or thicker
      },
    ],
  };

  const filteredData = {
    labels: originalData.labels.filter(
      (_, index) => originalData.datasets[0].data[index] >= threshold
    ),
    datasets: [
      {
        ...originalData.datasets[0],
        data: originalData.datasets[0].data.filter(
          (value) => value >= threshold
        ),
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          padding: 20,
          width: "50%",
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (tooltipItem) => {
            const value = tooltipItem.raw;
            return `Value: ${value}`;
          },
        },
      },
    },
    animation: {
      animateScale: true,
      animateRotate: true,
    },
  };

  //   const handleClick = (event, elements) => {
  //     if (elements.length > 0) {
  //       const { index } = elements[0];
  //       const label = filteredData.labels[index];
  //       const value = filteredData.datasets[0].data[index];
  //       alert(`Label: ${label}\nValue: ${value}`);
  //     }
  //   };

  return (
    <>
      <div className="donutFilter">
        <h6 style={{ padding: 30 }}>Sales By Area</h6>
        <div style={{ margin: 20 }}>
          <label>
            <select
              value={threshold}
              onChange={(e) => setThreshold(Number(e.target.value))}
              style={{ marginLeft: 10 }}
            >
              <option value={0}>Show All</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={150}>150</option>
            </select>
          </label>
        </div>
      </div>
      <div style={{ position: "relative", width: "100%", height: "200px" }}>
        <Doughnut data={filteredData} options={options} />
      </div>
    </>
  );
};

export default DonutChart;
